import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import { RootState, RootAction } from "@/lib/redux/types";
import { ThunkDispatch } from "redux-thunk";

export const useAppDispatch = () =>
  useDispatch<ThunkDispatch<RootState, undefined, RootAction>>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
